<template>
    <div>
        <section class="about_us section-padding">
            <div class="container">
                <div class="row  align-items-start">
                    <div class="col-md-4">
                        <div class="fun-facts-m">
                            <div class="cell">
                                <h2>
                                    VENDE
                                </h2>
                                <p>Tu Vehículo con Redautos</p>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-8">
                        <h3 class="mt-2 text-justify">
                            <span class="text-uppercase">{{ cotizacion.ClienteData }}</span>,
                            estás vendiendo un
                            <span class="text-uppercase">{{
                                cotizacion.titulo
                            }}</span>
                            con
                            <span>{{
                                numberWithoutDots(cotizacion.kilometraje)
                            }}</span>
                            kilometros.
                        </h3>
                    </div>
                </div>
                <div class="row  align-items-end">
                    <div class="col-md-4">
                        <div class="text-center d-none d-sm-block">
                            <img
                                src="/assets/images/slider/carros.png"
                                class="img-fluid"
                            />
                        </div>
                    </div>
                    <div class="col-md-8">
                        <div class="row">
                            <div class="col-md-4 col-sm-6 mb-2">
                                <b-card class="text-center p-2" no-body>
                                    <i
                                        class="fa fa-car"
                                        id="icon-fa"
                                        aria-hidden="true"
                                    ></i>
                                    <h5 class="mb-0 font-weight-light">
                                        {{ cotizacion.tipo_vehiculo }}
                                    </h5>
                                    <small class="text-danger">Clase</small>
                                </b-card>
                            </div>
                            <div class="col-md-4 col-sm-6 mb-2">
                                <b-card class="text-center p-2" no-body>
                                    <i
                                        class="fa fa-cog"
                                        id="icon-fa"
                                        aria-hidden="true"
                                    ></i>
                                    <h5 class="mb-0 font-weight-light">
                                        {{
                                            get_tipo_caja(
                                                cotizacion.vehiculoData
                                                    .tipo_caja
                                            )
                                        }}
                                    </h5>
                                    <small class="text-danger">Caja</small>
                                </b-card>
                            </div>
                            <div class="col-md-4 col-sm-6 mb-2">
                                <b-card class="text-center p-2" no-body>
                                    <i
                                        class="fa fa-tachometer"
                                        id="icon-fa"
                                        aria-hidden="true"
                                    ></i>
                                    <h5 class="mb-0 font-weight-light">
                                        {{
                                            numberWithoutDots(
                                                cotizacion.vehiculoData
                                                    .clindraje
                                            )
                                        }}
                                        cc
                                    </h5>
                                    <small class="text-danger">Motor</small>
                                </b-card>
                            </div>
                            <div class="col-md-4 col-sm-6 mb-2">
                                <b-card class="text-center p-2" no-body>
                                    <i
                                        class="fa fa-bolt"
                                        id="icon-fa"
                                        aria-hidden="true"
                                    ></i>
                                    <h5 class="mb-0 font-weight-light">
                                        {{
                                            get_combustible(
                                                cotizacion.vehiculoData
                                                    .combustible
                                            )
                                        }}
                                    </h5>
                                    <small class="text-danger"
                                        >Combustible</small
                                    >
                                </b-card>
                            </div>
                            <div class="col-md-4 col-sm-6 mb-2">
                                <b-card class="text-center p-2" no-body>
                                    <i
                                        class="fa fa-user-plus"
                                        id="icon-fa"
                                        aria-hidden="true"
                                    ></i>
                                    <h5 class="mb-0 font-weight-light">
                                        {{ cotizacion.vehiculoData.capacidad }}
                                    </h5>
                                    <small class="text-danger">Pasajeros</small>
                                </b-card>
                            </div>
                            <div class="col-md-4 col-sm-6 mb-2">
                                <b-card class="text-center p-2" no-body>
                                    <i
                                        class="fa fa-road"
                                        id="icon-fa"
                                        aria-hidden="true"
                                    ></i>
                                    <h5 class="mb-0 font-weight-light">
                                        {{ cotizacion.vehiculoData.potencia }}
                                        hp
                                    </h5>
                                    <small class="text-danger">Potencia</small>
                                </b-card>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <section class="section-padding gray-bg">
            <div class="container">
                <div class="section-header text-center">
                    <h3>
                        <span>Dependiendo de las condiciones de tu</span>
                        {{ cotizacion.tipo_vehiculo }}
                        <span
                            >, Redautos garantiza la venta del vehículo en este </span
                        >rango de precios:
                    </h3>
                </div>
                <div class="row justify-content-md-center">
                    <div class="col-md-10 col-sm-12 text-center">
                        <velocimetroVector
                            :retoma="
                                numberWithDots(typeof cotizacion.valores.vr_retoma_min != 'undefined' ? cotizacion.valores.vr_retoma_min : cotizacion.valores.vr_retoma)
                            "
                            :minimo="
                                numberWithDots(cotizacion.valores.vr_minimo)
                            "
                            :sugerido="
                                numberWithDots(cotizacion.valores.vr_sugerido)
                            "
                            :publicacion="
                                numberWithDots(cotizacion.valores.vr_publicado)
                            "
                            class=""
                        />
                    </div>
                    <div class="w-100"></div>
                    <div class="col-md-12">
                        <h5 class="mt-4 text-justify">
                            <span>
                                Nos encargamos de la venta de tu vehículo desde
                                el principio hasta el final, maximizando el
                                valor comercial del vehículo, garantizando el
                                pago y el traspaso.
                            </span>
                        </h5>
                    </div>
                    <div class="w-100"></div>
                    <div class="col-md-6 col-sm-12 text-center">
                        <b-button
                            :href="
                                'https://api.whatsapp.com/send?phone=57' +
                                    cotizacion.AsesorData.celular +
                                    '&text=Hola!%20' +
                                    cotizacion.AsesorData.nombre +
                                    '%20.Te%20escribo%20desde%20la%20pagina%20web%20de%20Redautos.%20Mi%20nombre%20es%20' +
                                    cotizacion.ClienteData +
                                    '%20y%20estoy%20interesado%20en%20vender%20mi%20carro%20' +
                                    cotizacion.titulo +
                                    '%20con%20ustedes!'"
                            block
                            class="mt-4 mb-4"
                            size="sm"
                            variant="dark"
                            target="_blank"
                        >
                            <i class="fa fa-whatsapp"></i> Chatea con tu asesor
                        </b-button>
                    </div>
                </div>
            </div>
        </section>
        <section class="section-padding">
            <div class="container">
                <div class="text-center">
                    <h3>Información de contacto del asesor</h3>
                </div>
                <div class="row justify-content-md-center">
                    <div class="col-md-4 col-sm-12 col-xs-12">
                        <div class="dealer_contact_info gray-bg">
                            <h6>
                                <i class="fa fa-user" aria-hidden="true"></i>
                                Nombre
                            </h6>
                            <a href="#"> {{ cotizacion.AsesorData.nombre }}</a>
                        </div>
                    </div>
                    <div class="col-md-4 col-sm-12 col-xs-12">
                        <div class="dealer_contact_info gray-bg">
                            <h6>
                                <i
                                    class="fa fa-envelope"
                                    aria-hidden="true"
                                ></i>
                                Correo
                            </h6>
                            <a :href="'mailto:' + cotizacion.AsesorData.email">
                                {{ cotizacion.AsesorData.email }}</a
                            >
                        </div>
                    </div>
                    <div class="col-md-4 col-sm-12 col-xs-12">
                        <div class="dealer_contact_info gray-bg">
                            <h6>
                                <i class="fa fa-phone" aria-hidden="true"></i>
                                Celular
                            </h6>
                            <a :href="'tel:' + cotizacion.AsesorData.celular">
                                {{ cotizacion.AsesorData.celular }}
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </div>
</template>

<script>
import velocimetroVector from "components/velocimetro/velocimetroVector";
import helper from "helpers/main-helper";
export default {
    props: ['cotizacion'],
    components: {
        velocimetroVector
    },
    methods: {
        numberWithDots(string) {
            return helper.numberWithDots(string);
        },
        numberWithoutDots(string) {
            return helper.numberWithoutDots(string);
        },
        get_combustible(code_combustible) {
            switch (code_combustible) {
                case "GSL":
                    return "Gasolina";
                    break;
                case "DSL":
                    return "Diesel";
                    break;
                case "ELT":
                    return "Electrico";
                    break;
                case "HBD":
                    return "Híbrido";
                    break;
                default:
                    return code_combustible;
            }
        },
        get_tipo_caja(code_caja) {
            switch (code_caja) {
                case "AT":
                    return "Automatica";
                    break;
                case "MT":
                    return "Mecanica";
                    break;
                case "TP":
                    return "Tiptronic";
                    break;
            }
        }
    }
};
</script>

<style lang="scss">
.fun-facts-m {
    border-radius: 10%;
    color: #ffffff;
    display: table;
    height: 100px;
    margin: 0 auto;
    text-align: center;
    width: 100%;
    background: #c91b1b;
}
</style>
